import { Directive, ElementRef, HostListener } from '@angular/core';
import { Configuration } from '../models';
import { AppConfig } from '../services/app.config';

@Directive({
  selector: '[appDefaultImage]'
})
export class DefaultImageDirective {
  constructor(private el: ElementRef) {
    this.Config = AppConfig.config;
  }

  private Config: Configuration;

  @HostListener('error') onError() {
    this.changeSource(`${this.Config.ImagesPath}\\NoFoodPhoto.png`);
  }

  private changeSource(source: string) {
    this.el.nativeElement.src = source;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/default-image.directive.ts